var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud-base',{attrs:{"url":_vm.url,"columns":_vm.columns,"onShow":() => {},"enableSearch":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }